<template lang="pug">
div.myOffice
  .topTitle
    span 我的办公室
    .btns
      Icon(type="md-arrow-dropup",@click="$emit('upData',eachIndex,DATA,)")
      Icon(type="md-arrow-dropdown",@click="$emit('downData',eachIndex,DATA)")
      Icon(type="md-git-branch",@click='logic')
      Icon(type="ios-trash",@click='delModel')
  .talkImg
    img(src="../../assets/case/department/myOffice.png")
  p.talkset 办公室功能设置
  .plan
    span a.
    Input(style="width: 200px",placeholder="请输入办公室功能",ref="inputBox",v-model="fun_office")
  component(
    v-disabled="seeState"
    v-if="condition"
    v-for='(item,index) in assemblyList',
    :key='index',
    @delModel='delCom(index)',
    :ref="item.name + index",
    :is='item.name',
    :data='item.data'
    @upData='upData(index)',
    @downData='downData(index)',
    @data1:data="val => item.data = val"
    :tableData.sync="tableData"
    :ha-id="haId"
    :task-id="taskId"
    :enableAI="enableAI"
  ).model
  div.drag(@drop="fun_drop",@dragover="allowDrop")
    p  把题型或者案例内容拖入此区域吧!
</template>
<script>
import mybus from "@/utils/main";
import Single from "../case/single";
import MultipleA from "../case/multiple";
import MultipleB from "../case/multiple";
import Fillblank from "../case/fillblank";
import EasyQuestion from "../case/easyQuestion";
import Material from "../case/material";
import CaseAxis from "../case/caseAxis";
import CaseTitle from "../case/caseTitle";
import smallCaseTitle from "../case/smallCaseTitle";
import CaseDialogue from "../case/caseDialogue";
import CaseGuide from "../case/caseGuide";
import CaseInfoBase from "../case/caseInfoBase";
import CaseDepartment from "../case/caseDepartment";
import CaseUpload from "../case/caseUpload";
import CaseAskAndAnswer from "../case/caseAskAndAnswer";
import determineQuestion from "../case/determineQuestion";
import TableQuestion from "../case/tableQuestion";
import ligatureQuestion from "../case/ligatureQuestion";
import CasePhotoText from "../case/casePhotoText";
import CaseSingleText from "../case/caseSingleText";
import CaseTitleText from "../case/caseTitleText";
import CaseVideo from "../case/caseVideo";
import MultipeChoice from "../case/multipeChoice";
import Divider from "../case/divider";
import SURVEY from "./survey"; // 现场调研

export default {
  inject: ["seeState"],
  props: ["assemblyName", "info", "eachIndex", "data", "fun_office1", "taskId", "haId", "taId", "cdId"],
  components: {
    Single,
    MultipleA,
    MultipleB,
    Fillblank,
    EasyQuestion,
    Material,
    CaseAxis,
    CaseInfoBase,
    CaseDepartment,
    CaseUpload,
    CaseAskAndAnswer,
    determineQuestion,
    TableQuestion,
    ligatureQuestion,
    CaseDialogue,
    CaseGuide,
    CaseTitle,
    CasePhotoText,
    CaseSingleText,
    CaseTitleText,
    CaseVideo,
    MultipeChoice,
    Divider,
    smallCaseTitle,
    SURVEY
  },
  data() {
    return {
      condition: true,
      showInput: false,
      form: {
        logic: ""
      },
      fun_office: "",
      // caseValue: ["FORMULATE", "EXECUTE", "ASSESS", "FINALITY"],
      assemblyList: [], // 拖进来的组件
      tableData: [],
      enableAI: false,
      aiDialogVisible: false,
      aiForm: {}
    };
  },
  watch: {
    tableData: {
      handler(val) {
        this.$emit("updateTableData", val);
      },
      deep: true,
      immediate: true
    },
    haId(newVal) {
      if (!newVal) {
        this.initHaId();
      }
    }
  },
  created() {
    console.log(this.data);
    if (this.data) {
      this.assemblyList = this.data.assemblyList || this.data;
    }
    console.log(this.assemblyList);
    this.fun_office = this.fun_office1;
  },
  computed: {
    caseValue() {
      return this.$store.state.Case.caseValue;
    },
    DATA() {
      return { talkList: false, assemblyList: this.assemblyList };
    },
    List() {
      return this.getData;
    },
    taskList() {
      return this.$store.state.task.task;
    }
  },
  methods: {
    async initHaId() {
      const index = +sessionStorage.getItem("CaseStage") - 1;
      const caseData = this.$store.state.Case.caseData?.[this.caseValue[index]];

      if (caseData?.HallId) {
        this.haId = caseData.HallId;
      } else {
        try {
          const res = await this.$http.getCasehallByPyIdAndCaseStep({
            pyId: this.Case?.basic?.id,
            caseStep: this.caseValue[index]
          });
          if (res.data.success) {
            this.haId = res.data.data.id;
          }
        } catch (e) {
          console.error("重新获取 haId 失败", e);
        }
      }
    },
    checkEnableAI() {
      this.$http
        .getEnableState()
        .then((res) => {
          if (res.data.success) {
            this.enableAI = res.data.data;
          } else {
            this.enableAI = false;
          }
        })
        .catch(() => {
          this.enableAI = false;
        });
    },
    upData(index) {
      // 题目点击向上移动
      if (index === 0) {
        return this.$Message.error("已经是第一个控件啦");
      }
      this.condition = false;
      [this.assemblyList[index], this.assemblyList[index - 1]] = [
        this.assemblyList[index - 1],
        this.assemblyList[index]
      ];

      this.$forceUpdate();
      setTimeout(() => {
        this.condition = true;
      }, 0);
    },
    downData(index) {
      // 题目点击向上移动

      if (index + 1 === this.assemblyList.length) {
        return this.$Message.error("已经是最后一个控件啦");
      }
      this.condition = false;

      [this.assemblyList[index], this.assemblyList[index + 1]] = [
        this.assemblyList[index + 1],
        this.assemblyList[index]
      ];
      this.$forceUpdate();
      setTimeout(() => {
        this.condition = true;
      }, 0);
    },
    getData(data) {
      return data;
    },
    delCom(index) {
      // delete this.assemblyList[index];
      // console.log(this.assemblyList[index].data.id);
      if (!this.assemblyList[index].data || !this.assemblyList[index].data.id) {
        this.assemblyList.splice(index, 1);
        return;
      }
      if (this.assemblyList[index].data.id) {
        /** 如果有ID 则需要调用后端接口 */
        this.$store.commit("deleteControl", this.assemblyList[index].data.id);
        // 直接删除
      }
      this.assemblyList.splice(index, 1);
      const obj = {};
      obj.type = "我的办公室";
      obj.deleteIndex = index;
      this.$store.commit("deleteQues", obj);
    },
    // 删除部门
    delModel() {
      this.$emit("delModel", "MYOFFICE");
    },
    fun_drop() {
      if (this.assemblyName !== "") {
        if (this.assemblyName !== "") {
          this.assemblyList.push({ name: this.assemblyName, data: {} });
          const obj = {};
          obj.type = "我的办公室";
          obj.listChild = this.assemblyName;
          this.$store.commit("addQues", obj);
        }
      }
    },
    allowDrop(e) {
      e.preventDefault();
    }
  },
  async mounted() {
    this.checkEnableAI();
    this.index = +sessionStorage.getItem("CaseStage");
    this.haId =
      this.$store.state.Case.caseData[
        this.caseValue[+sessionStorage.getItem("CaseStage") - 1]
      ].HallId;
    // 监听事件
    mybus.$on(`add${this.eachIndex}`, this.ObtainSubject);
  }
};
</script>

<style lang="stylus">
.myOffice
  width 854px
  padding 16px 32px 60px 32px
  .topTitle
    text-align left
    height 32px
    line-height @height
    position relative
    margin-bottom 16px
    font-size 14px
    font-weight bold
    color rgba(42, 46, 54, 0.8)
    .btns
      position absolute
      right 0
      top 0
      .ivu-icon
        color #3A76D2FF
        font-size 22px
        top 0
        margin-right 12px
        background #F2F5FAFF
        width 24px
        height 24px
        border-radius 4px
        text-align center
        line-height @height
        &:hover
          cursor pointer
  .talkImg
    margin-bottom 24px
    img
      width 100%
  .talkset
    height 32px
    line-height @height
    text-align left
    color rgba(42, 46, 54, 1)
    font-size 14px
    margin-bottom 24px
  .plan
    text-align left
    font-size 14px
    padding-bottom 24px
    border-bottom 1px solid rgba(42, 46, 54, 0.3)
    span
      margin-right 10px
  .drag
    min-width 790px
    height 100px
    background #fff
    border-radius 4px
    border 1px dashed rgba(128, 128, 128, 0.5)
    margin-top 24px
    cursor alias
    p
      font-size 14px
      font-family MicrosoftYaHeiUI
      color rgba(128, 128, 128, 0.5)
      line-height 100px
      text-align center
</style>
